<template>

    <form ref="avaliacao-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">


            <div class="form-group col-md-12">
                <label for="titulo">Título</label>
                <input type="text" class="form-control" name="titulo" maxlength="150" placeholder="Um breve título para facilitar a identificação nas buscas" v-model="model.titulo" required />
            </div>

            <div class="form-group col-md-4">
                <label for="notaAprovacao">Nota de Aprovação (%)</label>
                <input type="number" min="0" max="2099" class="form-control" name="notaAprovacao" placeholder="Nota de aprovação" v-model="model.notaAprovacao" required />
            </div>
            <div class="form-group col-md-4">
                <label for="tempoMaximo">Tempo Máximo (minutos)</label>
                <input type="number" min="0" max="2099" class="form-control" name="tempoMaximo" placeholder="Tempo máximo" v-model="model.tempoMaximo" required />
            </div>
            <div class="form-group col-md-2">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehAtivo" class="custom-control-input" v-model="model.ehAtivo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativo?</span>
                </label>
            </div>
            <div class="form-group col-md-2">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehEliminatorio" class="custom-control-input" v-model="model.ehEliminatorio">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Eliminatório?</span>
                </label>
            </div>

            <div class="col-md-12">
                <b-tabs>
                    <b-tab title="Mensagem Inicial" active>
                        <br />
                        <em>Caso você precise subir vídeos, favor não ultrapassar 2MB por vídeos</em>
                        <textarea v-model="model.mensagemInicial" v-htmleditor></textarea>
                    </b-tab>

                    <b-tab title="Visualizar">
                        <br />
                        <div v-html="model.mensagemInicial"></div>
                        <hr />
                    </b-tab>

                </b-tabs>
                <br />
            </div>

            <div class="col-md-12">
                <b-tabs>
                    <b-tab title="Mensagem de Aprovação" active>
                        <br />
                        <em>Caso você precise subir vídeos, favor não ultrapassar 2MB por vídeos</em>
                        <textarea v-model="model.mensagemAprovacao" v-htmleditor></textarea>
                    </b-tab>

                    <b-tab title="Visualizar">
                        <br />
                        <div v-html="model.mensagemAprovacao"></div>
                        <hr />
                    </b-tab>

                </b-tabs>
                <br />
            </div>

            <div class="col-md-12">
                <b-tabs>
                    <b-tab title="Mensagem de Reprovação" active>
                        <br />
                        <em>Caso você precise subir vídeos, favor não ultrapassar 2MB por vídeos</em>
                        <textarea v-model="model.mensagemReprovacao" v-htmleditor></textarea>
                    </b-tab>

                    <b-tab title="Visualizar">
                        <br />
                        <div v-html="model.mensagemReprovacao"></div>
                        <hr />
                    </b-tab>

                </b-tabs>
                <br />
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Próximo passo</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    

    export default {
        name: "avaliacao-form-create",
        components: {},
        mixins: [base],
        data: () => ({
           
            model: {},

            form: "avaliacao-form-create",

            resources: {
                create: 'avaliacao',
            },

        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false) return;
                if (!this.model.mensagemInicial) return;
                if (!this.model.mensagemAprovacao) return;
                if (!this.model.mensagemReprovacao) return;
                this.model.ehExcluido = false;
                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Teste criado com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                if (!_valid) this.defaultErrorResult("Preencha todos os campos obrigatórios");
                return _valid;
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

